import { create } from 'zustand';

interface ReelPublishState {
  disabled: boolean;
  loading: boolean;
  handlePublish: (() => void) | null;
  /** Подпись кнопки: «Опубликовать в 3 аккаунта», «Запланировать на 01.11 18:00 в 3 аккаунта». */
  label: string;
  /** «Не хватает: видео, тип контента» — кнопка при этом нажимается и показывает, чего нет. */
  hint: string;
  setPublishState: (state: { disabled: boolean; loading: boolean; handlePublish: (() => void) | null; label?: string; hint?: string }) => void;
  reset: () => void;
}

export const useReelPublishStore = create<ReelPublishState>((set) => ({
  disabled: true,
  loading: false,
  handlePublish: null,
  label: 'Опубликовать',
  hint: '',
  setPublishState: (state) => set({ label: 'Опубликовать', hint: '', ...state }),
  reset: () => set({ disabled: true, loading: false, handlePublish: null, label: 'Опубликовать', hint: '' }),
}));
